import React, { useEffect, useRef, useState } from "react";
import bag from "../../Assets/Images/Configuration/bag.svg";
import { Link, NavLink } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { apiCall } from "../../utils/axiosService";
import { API_URL } from "../../utils/apiRoutes";
import {
    errorToastMessage,
    successToastMessage,
} from "../../utils/toastMessage";
import { commonService } from "../../utils/commonService";
import { apiResponse } from "../../utils/apiResponse";
import { setAllDates } from "../../utils/slices/headerPropertySlice";
import reload from "../../Assets/Images/Revenue-management/reloadIcon.svg";
import moment from "moment";
function AsideRateshop() {
    const userDetail = commonService.getLoginUserData();
    const dispatch = useDispatch();
    const [asOfDate, setAsOfDate] = useState(null);

    const [activeRoute, setActiveRoute] = useState("/");

    const [propertyStatusList, setPropertyStatusList] = useState(null);
    const [selectedPropertyStatus, setSelectedPropertyStatus] = useState(null)

    const propertyDetail = useSelector(
        (store) => store.headerProperty.propertyDetail
    );

    const allLastDates = useSelector((store) => store.headerProperty.allDates);


    const getAsOfDate = async () => {

        let asOfDateResponse = await apiCall(
            {
                method: "POST",
                url: API_URL.BASE_API_URL.SnapShot + API_URL.AS_OF_DATE.AS_OF_DATE,
                body: { propertyCode: propertyDetail?.propertycode },
            },
            false
        );

        if (asOfDateResponse?.status_code === 0) {
            return errorToastMessage(asOfDateResponse?.message);
        } else if (asOfDateResponse?.status_code === 1) {
            setAsOfDate(
                asOfDateResponse?.data?.[0]?.last_data_refresh
                    ? asOfDateResponse?.data?.[0]?.last_data_refresh
                    : `${commonService.getDateForNode(new Date())} 00:00:00`
            );
        } else if (asOfDateResponse?.message === "Request failed with status code 403") {
            commonService.LogOutToUser()
        }
    };

    const getLastDateForAll = async () => {
        let lastDateResponse = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.SnapShot +
                    API_URL.AS_OF_DATE.ALL_LAST_REFRESH_DATE,
                body: { propertyCode: propertyDetail?.propertycode },
            },
            false
        );

        let response = apiResponse(false, lastDateResponse);

        if (response?.isValidate) {
            let dataFromApi = response?.data?.data;
            let reservationDate = "",
                BiDate = "",
                rateshopDate = "",
                occDate = "";

            dataFromApi?.forEach((item) => {
                if (item?.processType === "CREATE_WIDGET") {
                    let utcDate = moment.utc(item?.updatedAt);
                    BiDate = moment(utcDate).local().format("L hh:mm A");
                } else if (item?.processType === "REPORT_TO_UNI_RES") {
                    let utcDate = moment.utc(item?.updatedAt);
                    reservationDate = moment(utcDate).local().format("L hh:mm A");
                } else if (item?.processType === "REPORT_TO_UNI_OCC") {
                    let utcDate = moment.utc(item?.updatedAt);
                    occDate = moment(utcDate).local().format("L hh:mm A");
                } else if (item?.jobType === "RATE_SHOP") {
                    let utcDate = moment.utc(item?.updatedAt);
                    rateshopDate = moment(utcDate).local().format("L hh:mm A");
                }
            });

            dispatch(
                setAllDates({
                    BiDate,
                    reservationDate,
                    rateshopDate,
                    occDate,
                })
            );
        }

        if (!response?.isValidate) {
        }
    };

    const handlePropertyStatus = (list) => {
        if (propertyDetail?.propertycode) {
            let filterData = list?.filter(
                (x) => x?.propertyCode === propertyDetail?.propertycode
            );
            setSelectedPropertyStatus(filterData);
        }
    };

    const getPropertyStatus = async () => {
        let propertyStatusResponse = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.SnapShot +
                    API_URL.CRM_SNAPSHOT.GET_PROPERTY_STATUS,
                body: {
                    clientid: userDetail?.clientid ? userDetail?.clientid : "",
                },
            },
            false
        );

        let response = apiResponse(false, propertyStatusResponse);

        if (response?.isValidate) {
            handlePropertyStatus(response?.data?.data);
            setPropertyStatusList(response?.data?.data);
        }

        if (!response?.isValidate) {
            setPropertyStatusList(null);
            setSelectedPropertyStatus(null);
        }
    };

    useEffect(() => {
        if (propertyDetail) {
            getPropertyStatus()
            getAsOfDate();
            getLastDateForAll();
        }
        // }
    }, [propertyDetail]);


    const StaticMenuIcon = {
        Dashboard: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.94915 19H4.52542C3.68297 19 3 18.3732 3 17.6V6.4C3 5.62682 3.68297 5 4.52542 5H8.94915C9.79161 5 10.4746 5.62682 10.4746 6.4V17.6C10.4746 18.3732 9.79161 19 8.94915 19Z" stroke="#231F20" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M19.4746 10.6H15.0509C14.2084 10.6 13.5255 9.97319 13.5255 9.2V6.4C13.5255 5.62682 14.2084 5 15.0509 5H19.4746C20.3171 5 21 5.62682 21 6.4V9.2C21 9.97319 20.3171 10.6 19.4746 10.6Z" stroke="#231F20" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M19.4746 18.9999H15.0509C14.2084 18.9999 13.5255 18.3731 13.5255 17.5999V14.7999C13.5255 14.0267 14.2084 13.3999 15.0509 13.3999H19.4746C20.3171 13.3999 21 14.0267 21 14.7999V17.5999C21 18.3731 20.3171 18.9999 19.4746 18.9999Z" stroke="#231F20" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`,
        ParityCheck: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_1343_1599)">
<path d="M20.5684 20.2031H22.711C23.2287 20.2031 23.6485 19.7834 23.6485 19.2656V4.73438C23.6485 4.21659 23.2287 3.79688 22.711 3.79688H9.34253" stroke="#231F20" stroke-width="0.8" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M9.70189 3.79688H1.28906C0.771281 3.79688 0.351562 4.21659 0.351562 4.73438V19.2656C0.351562 19.7834 0.771281 20.2031 1.28906 20.2031H20.9277" stroke="#231F20" stroke-width="0.8" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M4.60753 3.79688H1.28906C0.771281 3.79688 0.351562 4.21659 0.351562 4.73438V19.2656C0.351562 19.7834 0.771281 20.2031 1.28906 20.2031H4.60753V3.79688Z" stroke="#231F20" stroke-width="0.8" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M4.60754 11.0903H23.6484" stroke="#231F20" stroke-width="0.8" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M4.60754 14.1279H23.6484" stroke="#231F20" stroke-width="0.8" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M4.60754 17.1655H23.6484" stroke="#231F20" stroke-width="0.8" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M23.6484 8.05273H0.351562" stroke="#231F20" stroke-width="0.8" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M10.9545 8.05273V20.203" stroke="#231F20" stroke-width="0.8" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M17.3015 8.05273V20.203" stroke="#231F20" stroke-width="0.8" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<defs>
<clipPath id="clip0_1343_1599">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>`,
        Benchmarking: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_1343_1612)">
<path d="M14.2386 21.1765H1.70587C1.15359 21.1765 0.705872 20.7288 0.705872 20.1765V5.23535C0.705872 4.68307 1.15359 4.23535 1.70587 4.23535H2.11764H4.94117H20.8823C21.4346 4.23535 21.8823 4.68307 21.8823 5.23535V18.4739" stroke="#231F20" stroke-miterlimit="10"/>
<path d="M6.35295 18.3531C7.91234 18.3531 9.17648 17.089 9.17648 15.5296C9.17648 13.9702 7.91234 12.7061 6.35295 12.7061C4.79356 12.7061 3.52942 13.9702 3.52942 15.5296C3.52942 17.089 4.79356 18.3531 6.35295 18.3531Z" stroke="#231F20" stroke-miterlimit="10"/>
<path d="M4.94121 4.23539H2.11768V2.82363C2.11768 2.04391 2.74972 1.41187 3.52944 1.41187C4.30916 1.41187 4.94121 2.04391 4.94121 2.82363V4.23539Z" stroke="#231F20" stroke-miterlimit="10"/>
<path d="M3.52942 1.41187H18.3529" stroke="#231F20" stroke-miterlimit="10" stroke-linecap="round"/>
<path d="M21.1765 22.5885C22.3461 22.5885 23.2941 21.6404 23.2941 20.4708C23.2941 19.5151 22.661 18.7077 21.7914 18.4442C21.5279 17.5746 20.7204 16.9414 19.7647 16.9414C19.3789 16.9414 19.0175 17.0451 18.7059 17.2254C18.3943 17.0451 18.0329 16.9414 17.6471 16.9414C16.6914 16.9414 15.8839 17.5746 15.6205 18.4442C14.7508 18.7077 14.1177 19.5151 14.1177 20.4708C14.1177 21.6404 15.0658 22.5885 16.2353 22.5885H21.1765Z" stroke="#231F20" stroke-miterlimit="10"/>
<path d="M18.0588 7.05884H4.52942C3.97713 7.05884 3.52942 7.50655 3.52942 8.05884V8.88237C3.52942 9.43465 3.97713 9.88237 4.52942 9.88237H18.0588C18.6111 9.88237 19.0588 9.43465 19.0588 8.88237V8.05884C19.0588 7.50655 18.6111 7.05884 18.0588 7.05884Z" stroke="#231F20" stroke-miterlimit="10"/>
<path d="M6.35297 12.7061V18.3531" stroke="#231F20" stroke-miterlimit="10"/>
<path d="M15.5294 13.4119H16.9412" stroke="#231F20" stroke-miterlimit="10" stroke-linecap="round"/>
<path d="M18.353 13.4119H19.7647" stroke="#231F20" stroke-miterlimit="10" stroke-linecap="round"/>
</g>
<defs>
<clipPath id="clip0_1343_1612">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>`,
        CompSetVariance: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<mask id="mask0_1343_1506" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="1" y="1" width="22" height="23">
<path d="M1.19922 1.2H22.7992V24H1.19922V1.2Z" fill="white"/>
</mask>
<g mask="url(#mask0_1343_1506)">
<path d="M20.7187 2.0001V16.272C20.7187 16.8243 20.271 17.272 19.7187 17.272H3.99994C3.44765 17.272 2.99994 16.8243 2.99994 16.272V2.0001" stroke="#231F20" stroke-miterlimit="10"/>
<path d="M13.2648 20.9023C13.2648 21.6013 12.6982 22.168 11.9992 22.168C11.3002 22.168 10.7336 21.6013 10.7336 20.9023C10.7336 20.2034 11.3002 19.6367 11.9992 19.6367C12.6982 19.6367 13.2648 20.2034 13.2648 20.9023Z" stroke="#231F20" stroke-miterlimit="10"/>
<path d="M11.9992 19.6367V17.1055" stroke="#231F20" stroke-miterlimit="10"/>
<path d="M6.93671 9.51172L9.46796 12.043" stroke="#231F20" stroke-miterlimit="10" stroke-linecap="round"/>
<path d="M6.93671 12.043L9.46796 9.51172" stroke="#231F20" stroke-miterlimit="10" stroke-linecap="round"/>
<path d="M15.7961 12.043L18.3273 14.5742" stroke="#231F20" stroke-miterlimit="10" stroke-linecap="round"/>
<path d="M15.7961 14.5742L18.3273 12.043" stroke="#231F20" stroke-miterlimit="10" stroke-linecap="round"/>
<path d="M5.03827 14.5742H8.20233C10.2993 14.5742 11.9992 12.8743 11.9992 10.7773C11.9992 8.68037 13.6991 6.98047 15.7961 6.98047H18.3273" stroke="#231F20" stroke-miterlimit="10" stroke-linecap="round"/>
<path d="M15.7961 4.44922L18.3273 6.98047L15.7961 9.51172" stroke="#231F20" stroke-miterlimit="10" stroke-linecap="round"/>
<path d="M1.76404 1.83398H22" stroke="#231F20" stroke-miterlimit="10" stroke-linecap="round"/>
<path d="M10.7336 5.71484C10.7336 6.41381 10.1669 6.98047 9.46796 6.98047C8.76899 6.98047 8.20233 6.41381 8.20233 5.71484C8.20233 5.01588 8.76899 4.44922 9.46796 4.44922C10.1669 4.44922 10.7336 5.01588 10.7336 5.71484Z" stroke="#231F20" stroke-miterlimit="10"/>
</g>
</svg>`,
        RateShopPayment: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <!-- Payment Terminal -->
  <rect x="3" y="2" width="18" height="15" rx="1" stroke="#231F20" stroke-width="1.5"/>
  <line x1="3" y1="5" x2="21" y2="5" stroke="#231F20" stroke-width="1.5"/>

  <!-- Compare Arrows -->
  <path d="M7 11H16" stroke="#231F20" stroke-width="1.5" stroke-linecap="round"/>
  <path d="M14 9L16 11L14 13" stroke="#231F20" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>

  <path d="M17 14H8" stroke="#231F20" stroke-width="1.5" stroke-linecap="round"/>
  <path d="M10 12L8 14L10 16" stroke="#231F20" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>

  <!-- Best Rate Check -->
  <circle cx="18" cy="8" r="2" stroke="#231F20" stroke-width="1.5"/>
  <path d="M17.3 8L17.8 8.5L18.8 7.5" stroke="#231F20" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>

  <!-- Stand -->
  <line x1="12" y1="17" x2="12" y2="20" stroke="#231F20" stroke-width="1.5"/>
  <circle cx="12" cy="21" r="1.2" stroke="#231F20" stroke-width="1.5"/>
</svg>`


    };


    return (
        <aside className="revenue-management-aside-main asideConfigurationMain container-menu-bar">
            <ul className="list-unstyled p-0 m-0">
                <li title="Dashboard">
                    <NavLink to="/rateshop/dashboard" className="revenue-aside-links">
                        <div
                            dangerouslySetInnerHTML={{
                                __html: StaticMenuIcon["Dashboard"],
                            }}
                        ></div>
                        <span className="main-menu-text">Dashboard</span>
                    </NavLink>
                </li>
                {
                    commonService.checkUserPropertyRole(propertyDetail?.propertyid, "Rateshop", "Parity Check", "isview") &&
                    <li title="Parity Check">
                        <NavLink to="/rateshop/paritycheck" className="revenue-aside-links">
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: StaticMenuIcon["ParityCheck"],
                                }}
                            ></div>
                            <span className="main-menu-text">Parity Check</span>
                        </NavLink>
                    </li>
                }

                {
                    commonService.checkUserPropertyRole(propertyDetail?.propertyid, "Rateshop", "Benchmarking", "isview") &&
                    <li title="Benchmarking">
                        <NavLink to="/rateshop/benchmarking" className="revenue-aside-links">
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: StaticMenuIcon["Benchmarking"],
                                }}
                            ></div>
                            <span className="main-menu-text">Benchmarking</span>
                        </NavLink>
                    </li>
                }


                {
                    commonService.checkUserPropertyRole(propertyDetail?.propertyid, "Rateshop", "CompSet Variance", "isview") &&
                    <li title="CompSet Variance">
                        <NavLink to="/rateshop/compsetvariance" className="revenue-aside-links">
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: StaticMenuIcon["CompSetVariance"],
                                }}
                            ></div>
                            <span className="main-menu-text">CompSet Variance</span>
                        </NavLink>
                    </li>
                }

                {
                    commonService.checkUserPropertyRole(propertyDetail?.propertyid, "Rateshop", "RateShop Payment", "isview") &&
                    <li title="RateShop Payment">
                        <NavLink to="/rateshop/rateshop-payment" className="revenue-aside-links">
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: StaticMenuIcon["RateShopPayment"],
                                }}
                            ></div>
                            <span className="main-menu-text">RateShop Payment</span>
                        </NavLink>
                    </li>
                }
            </ul>
        </aside>
    );
}

export default AsideRateshop;
